import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/core/services/getSettings';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

/**
 * Footer component
 */
export class FooterComponent implements OnInit {
  protected appSettings = ConfigService.settings;

  // set the currenr year
  year: number = new Date().getFullYear();
  companyInfo = this.appSettings.company;

  constructor() { }

  ngOnInit() {
  }

}
